import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { signedIn, signedOut } from "./guards/auth.guards";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    loadChildren: () => import("./pages/welcome/welcome.module").then((m) => m.WelcomePageModule),
  },
  {
    path: "login",
    canActivate: [signedOut],
    loadChildren: () => import("./pages/login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "login-verify",
    canActivate: [signedOut],
    loadChildren: () => import("./pages/login-verify/login-verify.module").then((m) => m.LoginVerifyPageModule),
  },
  {
    path: "forgot-password",
    loadChildren: () => import("./pages/forgot-password/forgot-password.module").then((m) => m.ForgotPasswordPageModule),
  },
  {
    path: "reset-password/:id",
    loadChildren: () => import("./pages/reset-password/reset-password.module").then((m) => m.ResetPasswordPageModule),
  },
  {
    path: "tabs",
    canActivate: [signedIn],
    loadChildren: () => import("./pages/shell/shell.module").then((m) => m.ShellPageModule),
  },
  { path: "**", redirectTo: "" },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
